// Composite Categories
export const SETTINGS_USER_SUBCATEGORY = {
  name: 'User Management',
  url: '/settings/user-management',
  id: 'user-management',
};

export const SETTINGS_CATEGORY = {
  name: 'Settings',
  url: '/settings',
  image: '',
  id: 'settings',
  sub_categories: [SETTINGS_USER_SUBCATEGORY],
};

export const ACCOUNT_PROFILE_SUBCATEGORY = {
  name: 'Profile',
  url: '/account/profile',
  id: 'profile',
};

export const ACCOUNT_PASSWORD_SUBCATEGORY = {
  name: 'Update Password',
  url: '/account/update-password',
  id: 'update-password',
};

export const ACCOUNT_CATEGORY = {
  name: 'Account',
  url: '/account',
  image: 'account-icon',
  id: 'account',
  sub_categories: [ACCOUNT_PROFILE_SUBCATEGORY, ACCOUNT_PASSWORD_SUBCATEGORY],
};

// Categories
export const HELP_CATEGORY = {
  name: 'Help',
  url: '/help',
  image: 'help-icon',
  id: 'help',
};

export const MORE_CATEGORY = {
  name: 'More',
  url: '/help',
  image: 'more-icon',
  id: 'more',
};

// SubCategories

export const HELP_SUBCATEGORY = {
  name: 'Help',
  url: '/help',
  id: 'help',
};

export const LOGOUT_SUBCATEGORY = {
  name: 'Log Out',
  url: '/login',
  id: 'logout',
};
